import { render, staticRenderFns } from "./ClinicPatientProfile.vue?vue&type=template&id=16eec540"
import script from "./ClinicPatientProfile.vue?vue&type=script&lang=js"
export * from "./ClinicPatientProfile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports